// src/modules/marketplace/pages/RealizationPage.tsx

import { FC, useCallback, useState } from "react"
import { Box, Button, Collapse, Container, Typography } from "@mui/material"
import { useLocation } from "react-router-dom"
import { useTitle } from "@/core/hooks"
import { useAppSelector } from "@/modules/app/hooks"
import { App } from "@/modules/app/interfaces"
import {
  BatchFilters,
  BatchesTable,
  CreateBatchForm,
  RealizationFilters,
  RealizationTable,
} from "../components/realization"

interface IProps {}

const RealizationContent: FC = () => {
  const [filtersReady, setFiltersReady] = useState(false)
  const handleInitialized = useCallback(() => setFiltersReady(true), [])

  return (
    <Box display="flex" flexDirection="column" height="100%" minHeight={0}>
      <RealizationFilters onInitialized={handleInitialized} />
      <Box flex={1} minHeight={0}>
        {filtersReady && <RealizationTable />}
      </Box>
    </Box>
  )
}

export const RealizationPage: FC<IProps> = () => {
  const { pathname } = useLocation()
  const isBatches = pathname.endsWith("batches")

  useTitle(
    isBatches ? "PR Маркетплейсы — Партии" : "PR Маркетплейсы — Реализация",
  )

  const [createOpen, setCreateOpen] = useState(false)

  const auth = useAppSelector((state) => state.auth)
  const userRoles = (auth.userInfo as App.OIDCUserInfo | undefined)?.roles ?? []
  const canWrite = userRoles.includes("marketplace:w")

  return (
    <Container
      maxWidth={false}
      sx={{ height: "100%", display: "flex", flexDirection: "column", py: 2 }}
    >
      {/* ── Реализация ──────────────────────────────────────────────── */}
      {!isBatches && <RealizationContent />}

      {/* ── Партии ──────────────────────────────────────────────────── */}
      {isBatches && (
        <Box display="flex" flexDirection="column" height="100%" minHeight={0}>
          {canWrite && (
            <Box mb={2} display="flex" justifyContent="flex-end">
              <Button
                variant="outlined"
                onClick={() => setCreateOpen((v) => !v)}
              >
                {createOpen ? "Отмена" : "Добавить партию"}
              </Button>
            </Box>
          )}
          <Collapse in={createOpen}>
            <Box mb={3}>
              <Typography variant="h6" mb={1}>
                Новая партия
              </Typography>
              <CreateBatchForm onSuccess={() => setCreateOpen(false)} />
            </Box>
          </Collapse>
          <BatchFilters />
          <Box flex={1} minHeight={0}>
            <BatchesTable canWrite={canWrite} />
          </Box>
        </Box>
      )}
    </Container>
  )
}
